import application from 'application/application';

const controller = 'DefaultPublicationsPublicationsDetailsController';

application.controller(controller, [
	'$scope',
	'$http',
	'$state',
	'$stateParams',
	'$timeout',
	'API',
	'helper',
	($scope, $http, $state, $stateParams, $timeout, API, helper) => {
		/** Instância de armazenamento de resposta. */
		$scope.publications = helper.responseStore();

		$scope.recordPublications = responseStore => {
			$http({
				...helper.http(API.publications, 'GET'),
				params: {
					...helper.httpFields([
						'id',
						'dataPublicacao',
						'dataDisponibilizacao',
						'numeroProcesso',
						'palavraChave',
						'diario',
						'edicao',
						'vara',
						'comarca',
						'orgao',
						'orgaoDescricao',
						'numeroOAB',
						'despacho',
						'conteudo',
						'paginaInicial',
						'paginaFinal',
						'visualizada',
						'prazo.id',
						'prazo.diaInteiro',
						'prazo.importante',
						'prazo.idLembrete',
						'prazo.idRepeticao',
						'prazo.idTipo',
						'prazo.localizacao',
						'prazo.observacoes',
						'prazo.titulo'
					]),
					registrosPorPagina: -1,
					IDs: $stateParams.publicationsIDs
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					if ($stateParams.print)
						$timeout(() => {
							window.print();

							$state.go('root.default.publications');
						});
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordPublications($scope.publications);

		/**********************************************************************/

		/**
		 *
		 */
		$scope.favoritePublications = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'favorite'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.unfavoritePublications = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'unfavorite'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.printPublications = () => window.print();

		/**
		 *
		 */
		$scope.downloadPublications = publications => {
			if (!Array.isArray(publications)) publications = [publications];

			window.open(
				helper.http(API.publications, 'download').url +
					'?IDs=' +
					publications.map(item => item.id).join(','),
				'_self'
			);
		};

		/**
		 *
		 */
		$scope.archivePublications = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'archive'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.restorePublications = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'restore'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.forwardPublications = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'forward'),
				method: 'POST',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.setPublicationsAsRead = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'setAsRead'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(
					response =>
						responseStore.updateItems(response.data.itens, true, 'id'),
					() => responseStore.rowbackItems(publications)
				)

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		/**
		 *
		 */
		$scope.setPublicationsAsUnread = (responseStore, publications) => {
			if (!Array.isArray(publications)) publications = [publications];

			$http({
				...helper.http(API.publications, 'setAsUnread'),
				method: 'PUT',
				data: {
					itens: publications
				}
			})
				.then(response => {
					responseStore.updateItems(response.data.itens, true, 'id'),
						() => responseStore.rowbackItems(publications);

					$state.go('root.default.publications');
				})

				.finally(() => responseStore.setItemsAsNotBusy(publications));
		};

		$scope.getFavoritePublications = publications =>
			publications.filter(item => item.favorita);

		$scope.areAllPublicationsFavorites = publications => {
			let favorites = publications.filter(item => !!item.favorita);

			return favorites.length > 0 && favorites.length === publications.length;
		};
	}
]);

export default controller;
